/* Load helpers to handlebars. Must be imported before any hndb template are processed */
import Handlebars from '../shared/handlebar-helpers';

import menuHndb from '../../templates/menu.handlebars';
import '../../styles/app.scss';
import main from './main';

import Session from '../shared/session';
import Menu from './menu';
import ApiService from '../shared/services';
import Login from './views/login';
import { Modal } from '../shared/modal';
import { handleQuotesClick } from './menu-handlers/quotes-click';
import { getLangFile, getCurrencyCode } from '../shared/shared';

/* Events specific to the seller module */
const EVENTS = {
    OS_READY: 'omniseller:ready'
};

const init = async (app) => {
    const {id: cartId, version} = await app.service.getCartDetails() ?? {id: null, version: null};

    if (!cartId) {
        app.session.sessionDetails = app.session.getBaseSession().sessionDetails;
    } else {
        app.session.sessionDetails = {
            currentCartId: cartId,
            currentCartVersion: version,
        };
    }

    const { ahiaSessionId: osAhiaSessionId } = app.session.sessionDetails;
    const { ahiaSessionId } = app.service.getSession() ?? {ahiaSessionId: null}

    /* Session has changed since the last time we ran the app. Or we don't have a session*/
    if (!osAhiaSessionId || (osAhiaSessionId !== ahiaSessionId)) {
        const { data: { seller, quote_templates, share_mediums, customer_groups, prospect, activity, suggested_message } } = await app.service.getSessionData();

        app.session.set({
            sellerDetails: {
                id: seller.id,
                firstName: seller.first_name,
                username: seller.username,
                countryCode: seller.default_country,
                langCode: seller.langCode ?? navigator.language
            },
        });

        app.session.sessionDetails = {
            ...app.session.sessionDetails,
            activity: activity,
            templates: quote_templates,
            shareMediums: share_mediums,
            customerGroups: customer_groups,
            prospect,
            suggestedMessage: suggested_message || {
                label: '',
                enable_user_instruction: false
            },
        };
    }

    
    app.session.sessionDetails = {
        ...app.session.sessionDetails,
        ahiaSessionId
    };

    const lang = app.session.sellerDetails.langCode.substring(0, 2);
    const langFile = await getLangFile(lang);
    Handlebars.translation = langFile;

    // Check for currency code in DOM
    const currencyCode = getCurrencyCode();
    if (currencyCode) {
        app.session.sessionDetails = {
            ...app.session.sessionDetails,
            currencyCode: currencyCode
        };
    }

    return true;
}

const startApp = async() => {
    const login = new Login(new Modal({ maxWidth: '300px'}));
    const app = {
        session: new Session('sellerSession'),
        service: new ApiService('seller', login, BCSuite),
        login,
        menu: new Menu({
            id: 'adv-menu', 
            className: 'scf-adv-menu-popup scf-adv-menu-popup--pulsate', 
            img: `url(${__webpack_public_path__}/images/os-icon.png)`,
            onClick: (args) => handleQuotesClick(args, app),
        })
    };

    await init(app);
    main(app);

    /* Public API surface for external scripts */
    const omniSeller = {
        api: {
            service: app.service,
            session: app.session,
        },
        ready: true,
    };

    window.omniSeller = omniSeller;

    window.dispatchEvent(new CustomEvent(EVENTS.OS_READY, {
        detail: { omniSeller }
    }));

    return app;
}


if (process.env.NODE_ENV === 'development') {
    /* Simulate OS being loaded by BCFC */
    setTimeout(async() => {
        const app = await startApp();
        window.app = app;
    }, 2000);
} else {
    startApp();
}
